/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { HttpHeaders } from '@angular/common/http';
import { JobCategory } from '../../../interfaces/masters/jobCategory';

@Injectable()
export class JobCategoryApi {
  private readonly apiController: string = '';

  constructor(private api: HttpService) { }

  list(url: string, options?: any): Observable<any[]> {
    const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
    //header.append('Content-Type', 'applications/json');
    //headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    //header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json"}});
  }

  getById(url: string, options?: any): Observable<JobCategory> {
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.get(url,header);
  }

//   add(url:string, data: Payers):Observable<Payers>{
//     let header = new HttpHeaders();
//     header.append('Content-Type', 'applications/json');
//     header.append('Accept','application/vnd.ezovion.hateoas+json');
//     return this.api.post(this.apiController + url, data, header);
//   }

//   update(url:string, data: Payers):Observable<any>{
//     let header = new HttpHeaders();
//     header.append('Content-Type', 'applications/json');
//     header.append('Accept','application/vnd.ezovion.hateoas+json');
//     return this.api.put(this.apiController + url, data, header);
//   }

//   delete(url: string):Observable<any>{
//     return this.api.delete(url);
//   }
}
